export { SORT_TYPES } from './sortTypes';

export const YEAR_OVER_YEAR_COLUMNS = [
  { id: 'year', label: 'Fiscal Year', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'total_raised', label: 'Total Raised', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'donor_count', label: 'Donors', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'average_gift', label: 'Average Gift', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'new_donors', label: 'New Donors', defaultVisible: true, sortable: true, sortType: 'number' },
];

export const getDefaultVisibleColumns = () =>
  YEAR_OVER_YEAR_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  YEAR_OVER_YEAR_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
